import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithCustomToken } from 'firebase/auth';

const HUB_BACKEND = 'http://24.199.87.96:8005';
const NARA_BACKEND = '/api';
const HUB_URL = 'http://24.199.87.96:3005';

export default function HubAuth() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('No se proporcion\u00f3 token de autenticaci\u00f3n.');
      setLoading(false);
      return;
    }

    (async () => {
      try {
        // 1. Exchange token with Hub backend
        const exchangeRes = await fetch(`${HUB_BACKEND}/auth/exchange-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });

        if (!exchangeRes.ok) {
          const errData = await exchangeRes.json().catch(() => ({}));
          throw new Error(errData.detail || 'Error al validar token con NARA Hub');
        }

        const exchangeData = await exchangeRes.json();
        const { firebase_custom_token } = exchangeData;

        // 2. Sign in to Firebase with custom token
        const cred = await signInWithCustomToken(auth, firebase_custom_token);
        const idToken = await cred.user.getIdToken();

        // 3. Authenticate with NARA AI backend
        const authRes = await fetch(`${NARA_BACKEND}/auth/firebase`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: idToken }),
        });

        if (!authRes.ok) {
          const errData = await authRes.json().catch(() => ({}));
          throw new Error(errData.detail || 'Error al autenticar con NARA AI');
        }

        const data = await authRes.json();

        // 4. Save to localStorage (NARA AI uses "name" not "nombre")
        localStorage.setItem('user_id', data.user_id);
        localStorage.setItem('user_email', data.email);
        localStorage.setItem('user_name', data.name);
        localStorage.setItem('hub_origin', 'true');

        // 5. Navigate to dashboard
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('[HubAuth] Error:', err);
        setError(err.message || 'Error desconocido durante la autenticaci\u00f3n');
        setLoading(false);
      }
    })();
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderRadius: 16,
        padding: '40px 48px',
        textAlign: 'center',
        maxWidth: 420,
        width: '90%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      }}>
        {loading && !error ? (
          <>
            <div style={{
              width: 48,
              height: 48,
              border: '4px solid #e2e8f0',
              borderTopColor: '#1e3a5f',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 24px',
            }} />
            <h2 style={{
              margin: '0 0 8px',
              color: '#1e293b',
              fontSize: 20,
              fontWeight: 600,
            }}>
              Autenticando desde NARA Hub...
            </h2>
            <p style={{
              margin: 0,
              color: '#64748b',
              fontSize: 14,
            }}>
              Por favor espera un momento
            </p>
          </>
        ) : (
          <>
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#fef2f2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              fontSize: 24,
            }}>
              !
            </div>
            <h2 style={{
              margin: '0 0 12px',
              color: '#1e293b',
              fontSize: 20,
              fontWeight: 600,
            }}>
              Error de autenticaci&oacute;n
            </h2>
            <p style={{
              margin: '0 0 24px',
              color: '#64748b',
              fontSize: 14,
              lineHeight: 1.6,
            }}>
              {error}
            </p>
            <a
              href={HUB_URL}
              style={{
                display: 'inline-block',
                padding: '10px 24px',
                background: '#1e3a5f',
                color: '#fff',
                borderRadius: 8,
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Volver a NARA Hub
            </a>
          </>
        )}
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
